import React, { useState, useEffect } from "react";
import {
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
} from "@mui/material";
import { updateVision } from "../../api/visions";
import PlanIntelligenceSuggestion from "./PlanIntelligenceSuggestion";
import PendingActionNotice from "../common/PendingActionNotice";

function VisionEditDialog({ vision, onClose, onSaved }) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (vision) {
      setTitle(vision.title || "");
      setDescription(vision.description || "");
      setErrorMessage("");
    }
  }, [vision]);

  if (!vision) return null;

  async function handleSave() {
    setLoading(true);
    setErrorMessage("");
    try {
      await updateVision(vision.id, {
        title,
        description,
      });
      onSaved?.();
      onClose();
    } catch (err) {
      setErrorMessage(err?.message || "Unable to save this vision.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Dialog open onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit Vision</DialogTitle>

      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {loading ? (
            <PendingActionNotice
              compact
              title="Saving vision"
              body="Updating your direction and refreshing your plan."
            />
          ) : null}

          {errorMessage ? <Alert severity="error">{errorMessage}</Alert> : null}

          <TextField
            label="Vision title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
            autoFocus
          />

          <TextField
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            multiline
            rows={3}
            fullWidth
          />
          <PlanIntelligenceSuggestion
            itemType="vision"
            payload={{ title, description }}
            applyLabel="Use this wording"
            onApply={(suggestion) => {
              if (suggestion.suggested_title) setTitle(suggestion.suggested_title);
              if (suggestion.suggested_description) setDescription(suggestion.suggested_description);
            }}
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={loading || !title.trim()}
        >
          {loading ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default VisionEditDialog;
